const perfis = [
  "ADM",
  "LOJA",
  "CRC",
  "FINANCEIRO",
  "COMERCIAL",
  "ECOMMERCE",
  "REPRESENTANTE",
  "LOJA_ADM",
  "REPRESENTANTE_ADM",
  "HOMOLOG USER",
  "TRANSPORTE",
  "PGC",
  "GESTOR DE CANAL",
  "SUPERVISOR DE CANAL",
  "LOJA_MM",
  "LOJA_ADM_MM",
  "BACKOFFICE_MM",
  "FISCAL / CONTABILIDADE",
  "TECELAGEM",
  "PILOTO_MM",
  "PILOTO_ADM_MM",
  "SUPORTE",
  "KEY USER",
  "GOVERNANÇA",
  "BACKOFFICE_ADM_LOJAS",
  "Estoque",
  "Marketing",
  "FRANQUEADO_ADM",
  "FRANQUEADO_GERENTE",
  "FRANQUEADO_VENDEDOR",
  "FRANQUIAS_ADM",
];

export function isFranqueadoProfile(userDetail) {
  const profiles = userDetail?.UsuarioPerfis || [];

  return profiles.some(
    (perfil) =>
      (perfil?.Canais || []).includes("FRANQUIA") ||
      (perfil?.TiposPessoa || []).includes("FRANQUIA"),
  );
}

export default perfis;
